module.exports = __webpack_public_path__ + "static/media/ic-padlock.d2a6adc6.svg";